import React, {Fragment, useContext, useEffect, useState} from "react";
import CardContainer from "../../../components/CardContainer";
import Card from "../../../components/Card";
import {Link} from "react-router-dom";
import {LoaderContext} from "../../../context/LoaderContext";
import ModalConfirm from "../../../components/ModalConfirm";
import NsDataTable from "../../../components/tabelle/NsDataTable";
import {deleteTitoloUtenteApi, getTitoliUtenteApi} from "../../../services/UtentiServices";

function ListTitoli() {

    const [loadingData, setLoadingData] = useState(true);
    const [data, setData] = useState([]);
    const [titoloSel, setTitoloSel] = useState(null);
    const [show, setShow] = useState(false);

    const {startChiamata, endChiamata} = useContext(LoaderContext);

    async function getTitoli() {
        startChiamata();
        const response = await getTitoliUtenteApi();
        setData(response.data.data);
        setLoadingData(false);
        endChiamata();
    }

    useEffect(() => {
        if (loadingData === true) {
            getTitoli()
        }
    }, []);

    const openModalDel = (utente) => {
        setTitoloSel(utente)
        setShow(true);
    }

    async function deleteTitolo() {
        setShow(false);
        startChiamata();
        const response = await deleteTitoloUtenteApi(titoloSel.id_titolo);
        setData(response.data.data);
        endChiamata();
    }

    return (
        <CardContainer>
            <Card
                icon={'fas fa-tag'}
                title={'Titoli'}
                getBottoniDx={() =>
                    <Link to="/upd-titolo" className={"btn btn-card"}>
                        <i className="fas fa-plus-circle"/> Aggiungi
                    </Link>
                }>
                <ModalConfirm
                    show={show}
                    handleClose={() => setShow(false)}
                    handleOk={deleteTitolo}
                    testo={"Sicuro di voler eliminare il id_titolo: " + (titoloSel
                        && (titoloSel.id_titolo)) + "?"}/>
                {
                    loadingData ? (
                        <p>Caricamento in corso...</p>
                    ) : (
                        <NsDataTable
                            data={data}
                            columns={[
                                {
                                    name: 'Titolo',
                                    selector: row => row.id_titolo,
                                    sortable: true,
                                },
                                {
                                    name: 'Tipo',
                                    selector: row => row.tipo == '1' ?
                                        <span className={"rfi-etichetta rfi-etichetta--verde"}>Titolo 1</span>
                                        : <span className={"rfi-etichetta rfi-etichetta--blu"}>Titolo 2</span>,
                                    sortable: true,
                                },
                                {
                                    name: '',
                                    selector: row => <Fragment>
                                        <div className="btn-group" role="group" aria-label="Button group with nested dropdown">
                                            <div className="btn-group" role="group">
                                                <button id="btnGroupDrop1" type="button" className="btn btn-dark dropdown-toggle"
                                                        data-bs-toggle="dropdown" aria-expanded="false">
                                                    <i className="fa-solid fa-bars"></i>
                                                </button>
                                                <ul className="dropdown-menu" aria-labelledby="btnGroupDrop1">
                                                    <li>
                                                        <Link to={"/upd-titolo/" + row.id_titolo}
                                                              className="dropdown-item"
                                                              data-toggle="tooltip" title="Modifica">
                                                            <i className="fas fa-pen"/> Modifica
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <button className="dropdown-item"
                                                                data-toggle="tooltip" title="Elimina" onClick={() => {
                                                            openModalDel(row)
                                                        }}>
                                                            <i className="fas fa-trash"/> Elimina
                                                        </button>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </Fragment>,
                                    sortable: false,
                                    right: true,
                                }
                            ]}
                            addPagination={true}
                            funzioneFiltro={(item, filtro) => {
                                return (item.id_titolo && item.id_titolo.toLowerCase().includes(filtro.toLowerCase()))
                                    || (item.tipo == '1' && 'titolo 1'.includes(filtro.toLowerCase()))
                                    || (item.tipo == '2' && 'titolo 2'.includes(filtro.toLowerCase()))
                            }}
                        >
                        </NsDataTable>
                    )}
            </Card>
        </CardContainer>
    );
}

export default ListTitoli;
